import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {assetsTableReady,rowsPerPageState,searchTextState,paginationState,assetIdForAction,previousFilterStatus,previousFilterVendor,previousWorkLocationType,previousWorkLocationId} from '../redux/assets'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/assetsTable.css'


import {EntityStatus,Vendors,WorkLocations,EntityType,Kitchens} from '../../../common/DropDowns/index'


import * as Helpers from '../../../common/helpers'


function filterUnwantedData(assetsData) {
    let array = []
    if (assetsData && assetsData.data && assetsData.data.list) {
        array = assetsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.name = lineData.name ? lineData.name : "NA"
            newLineData.equipment_category = lineData.equipment && lineData.equipment.equipment_category && lineData.equipment.equipment_category.name ? lineData.equipment.equipment_category.name : "NA"
            newLineData.dop =lineData.dop ? Helpers.getDateTimeFormatForUTC(lineData.dop) : ""
            newLineData.serial_number = lineData.serial_number ? lineData.serial_number : "NA"
           

            if(lineData.location_type==="Kitchen"){
                 newLineData.location = lineData.kitchen_work_location && lineData.kitchen_work_location.name ? lineData.kitchen_work_location.name : "NA"
            }else{
                 newLineData.location = lineData.office_work_location && lineData.office_work_location.name ? lineData.office_work_location.name : "NA"
             }
            newLineData.status = lineData.status ? lineData.status : "NA"
            newLineData.tag_name = lineData.tag_name ? lineData.tag_name : "NA"
            newLineData.vendor = lineData.vendor && lineData.vendor.name ? lineData.vendor.name : "NA"
            newLineData.city = lineData.city && lineData.city.name ? lineData.city.name : "NA"
            newLineData.equipment = lineData.equipment && lineData.equipment.name ? lineData.equipment.name : "NA"
        


            newArray[i] = newLineData
        }
    }
    return newArray
}


class AssetsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            assetsData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_vendor:"",
            filter_status:"ACTIVE",
            workLocationType:"",
            workLocationId:"",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(assetsTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.ASSETS_TABLE))
        this.props.dispatch(subHeaderDataUpdate())


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

            let previousFilterStatus=""
            let previousFilterVendor=""

        let previousWorkLocationType=""
        let previousWorkLocationId=""

         if (this.props.assets && this.props.assets.previousFilterStatus && this.props.assets.previousFilterStatus!==undefined) {
            previousFilterStatus=this.props.assets.previousFilterStatus
         }         

         if (this.props.assets && this.props.assets.previousFilterVendor && this.props.assets.previousFilterVendor!==undefined) {
            previousFilterVendor=this.props.assets.previousFilterVendor
         }

         if (this.props.assets && this.props.assets.previousWorkLocationType && this.props.assets.previousWorkLocationType!==undefined) {
            previousWorkLocationType=this.props.assets.previousWorkLocationType
         }
         if (this.props.assets && this.props.assets.previousWorkLocationId && this.props.assets.previousWorkLocationId!==undefined) {
            previousWorkLocationId=this.props.assets.previousWorkLocationId
         }
         
         this.setState({
              filter_status:previousFilterStatus,
              filter_vendor:previousFilterVendor,
              workLocationType:previousWorkLocationType,
              workLocationId:previousWorkLocationId
         },() => {
            this.getAssetsData();
        });

        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getAssetsData = () => {
        apiService.getAssetsData(this.state.filter_status,this.state.filter_vendor,this.state.workLocationType,this.state.workLocationId)
            .then(assetsData => {
                if (assetsData && this.isComponentMounted) {
                    this.validateBuildNumber(assetsData)
                    if (assetsData.status === "SUCCESS") {
                        let array = filterUnwantedData(assetsData), pageNo = 1
                        if (this.props.assets && this.props.assets.previousPaginationValue) {
                            pageNo = this.props.assets.previousPaginationValue
                        }
                        this.setState({
                            assetsData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: assetsData.reason ? assetsData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(assetsTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(assetsTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

     entityStatusChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterStatus(""))
             this.setState({
                filter_status :"",            
            })
        }else{
            this.props.dispatch(previousFilterStatus(data.value))
            this.setState({
                filter_status :data.value,            
            })
        }
    }

    vendorChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterVendor(""))
             this.setState({
                filter_vendor :"",            
            })
        }else{
            this.props.dispatch(previousFilterVendor(data.value))
            this.setState({
                filter_vendor :data.value,            
            })
        }
    }


   workLocationTypeChange = (data) => {
        
         if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousWorkLocationType(""))
             this.setState({
                workLocationType:"",
                workLocationId:"",
            },() => {
                this.props.dispatch(previousWorkLocationId(""))
                this.props.dispatch(previousWorkLocationType(""))
            });
        }else{
            this.props.dispatch(previousWorkLocationType(data.value))
            this.setState({
                workLocationType:data.value
            })
        }
    }

    workLocationChange = (data) => {
        
         if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousWorkLocationId(""))
             this.setState({
                workLocationId:""
            })
        }else{
            this.props.dispatch(previousWorkLocationId(data.value))
            this.setState({
                workLocationId:data.value
            })
        }
    }


    kitchenChange = (data) => {
        
         if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousWorkLocationId(""))
             this.setState({
                workLocationId:""
            })
        }else{
            this.props.dispatch(previousWorkLocationId(data.value))
            this.setState({
                workLocationId:data.value
            })
        }
    }


    

    assetsGroupChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterVendor(""))
             this.setState({
                filter_vendor :"",            
            })
        }else{
            this.props.dispatch(previousFilterVendor(data.value))
            this.setState({
                filter_vendor :data.value,            
            })
        }
    }


    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.assets && this.props.assets.previousRowsPerPageValue) {
            value = this.props.assets.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/assets/addEdit",this.props.user)){
                    return(
                        <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                            <button className="btn btn-primary button-custom"
                                    style={{ marginLeft: "5px" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.props.dispatch(assetIdForAction())
                                        this.props.history.push("/dashboard/assets/addEdit")
                                    }}>
                                    Add
                                </button>
                         </div>

                        )
                      }
                   })()}
                   
                   
                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <EntityStatus type="ASSETS" entityStatusChange={this.entityStatusChange} selectedValue={this.state.filter_status} /> 
                    </div>
                    </div>
                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <Vendors vendorChange={this.vendorChange} selectedValue={this.state.filter_vendor} /> 
                    </div>
                    </div>

                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">

                    <EntityType entityTypeChange={this.workLocationTypeChange} selectedValue={this.state.workLocationType} type="WORK_LOCATIONS" />

                    </div>


                    {(() => {
                         if(this.state.workLocationType!=="Kitchen" && this.state.workLocationType && this.state.workLocationType!=="" && this.state.workLocationType!==undefined){
                         return (
                            <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                 <WorkLocations type={this.state.workLocationType} workLocationChange={this.workLocationChange} selectedValue={this.state.workLocationId} />
                            </div>
                          )
                         }
                         if(this.state.workLocationType==="Kitchen" && this.state.workLocationType && this.state.workLocationType!=="" && this.state.workLocationType!==undefined){
                         return (
                             <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                 <Kitchens comboType="asset_location" kitchenChange={this.kitchenChange} selectedValue={this.state.workLocationId} />
                            </div>
                         )
                         }
                         })()}

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredAssetList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.assetsData.length>=(this.props.assets.previousPaginationValue*this.props.assets.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.assets.previousPaginationValue*this.props.assets.previousRowsPerPageValue)-this.props.assets.previousRowsPerPageValue+1} to {this.props.assets.previousPaginationValue*this.props.assets.previousRowsPerPageValue} of {this.state.assetsData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.assets.previousPaginationValue*this.props.assets.previousRowsPerPageValue)-this.props.assets.previousRowsPerPageValue+1} to {this.state.assetsData.length} of {this.state.assetsData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredAssetList = () => {
       
        this.props.dispatch(assetsTableReady(false))
        this.resetSearchAndPagination()
        this.getAssetsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
   


    resetFilterValues = () => {
        this.props.dispatch(assetsTableReady(false))
        this.setState({
            filter_status:"",
            filter_vendor:"",
            workLocationType:"",
            workLocationId:"",
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterStatus(""))
            this.props.dispatch(previousFilterVendor(""))
            this.props.dispatch(previousWorkLocationId(""))
            this.props.dispatch(previousWorkLocationType(""))

            this.getAssetsData()
        });

        
    }

    actionButtonsCreator = (cell, row) => {
        let editButton =""


        if(Helpers.checkPrivileges("/dashboard/assets/addEdit",this.props.user)){
        
            editButton=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editAsset(row)
                }}>
                Edit
            </button>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.assets && this.props.assets.previousPaginationValue
            && this.props.assets.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editAsset = (row) => {
        if (row && row.id) {
            this.props.dispatch(assetIdForAction(row.id))
            this.props.history.push("/dashboard/assets/addEdit")
        } else {
            this.dialog.show({
                title: "Asset Identification number not found",
                body: 'Asset id is not available, So not able edit assets',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.assets && this.props.assets.previousRowsPerPageValue) {
            sizeperPage = this.props.assets.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="assets-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.assetsData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                        
                   {/* <TableHeaderColumn
                        dataField="name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>*/}
                    <TableHeaderColumn
                        dataField="equipment"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Equipment
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="equipment_category"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Category
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="vendor"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Vendor
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="location"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Location
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="city"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       City
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="serial_number"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       SL/No
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="tag_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Tag
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="status"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Status
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="dop"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       DOP
                    </TableHeaderColumn>
                    
                    
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        assets: state.assets
    }
}

export default connect(mapStateToProps)(withRouter(AssetsTable))


// WEBPACK FOOTER //
// ./src/modules/Assets/Components/AssetsTable.js